module.exports = __webpack_public_path__ + "img/wh3.ecb03363.png";